import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {fetchTransactionType, addTransactionType} from "../../slices/TransactionHistorySlice/TransactionTypeSlice";

const AddSurveyStatus = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    title: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "val" || name === "optionType" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      title: formData.title
    };

    const resp = await dispatch(addTransactionType(data));
    // Reset form
    if(!resp.error){
        setFormData({
            title: ""
          });
        dispatch(fetchTransactionType());
    }
   
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 max-w-md mx-auto">
      <input
        type="text"
        name="title"
        placeholder="Title"
        value={formData.title}
        onChange={handleChange}
        className="w-full p-1 border rounded"
        required
      />
      
 
      <button
        type="submit"
        className="w-full bg-[var(--mainCol)] text-white p-2 rounded"
      >
        Add Redeem Type
      </button>
    </form>
  );
};

export default AddSurveyStatus;
